import { ExternalLink } from 'lucide-react';
import type { ChatSettings } from './chat.types';

interface MessengerTabProps {
  settings: ChatSettings;
}

export function MessengerTab({ settings }: MessengerTabProps) {
  const { messenger_page_id } = settings;
  const href = messenger_page_id ? `https://m.me/${messenger_page_id}` : null;

  return (
    <div className="flex flex-col items-center justify-center h-full gap-5 px-6 text-center">
      <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center">
        <svg className="w-9 h-9 text-blue-500" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 2C6.477 2 2 6.145 2 11.243c0 2.921 1.439 5.529 3.694 7.247V22l3.37-1.851c.9.249 1.853.383 2.836.383C17.523 20.532 22 16.387 22 11.243 22 6.145 17.523 2 12 2zm1.21 12.385l-3.07-3.27-6.002 3.27L10.9 9.614l3.148 3.27 5.924-3.27-6.763 4.771z" />
        </svg>
      </div>

      <div>
        <p className="font-semibold text-gray-900 text-base">Chat on Messenger</p>
        <p className="text-sm text-gray-500 mt-1">
          {href
            ? 'Tap below to open a conversation on Facebook Messenger.'
            : "We're available on Facebook Messenger."}
        </p>
      </div>

      {href ? (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-blue-500 text-white text-sm font-medium hover:bg-blue-600 transition-colors"
        >
          <ExternalLink className="w-4 h-4" />
          Open Messenger
        </a>
      ) : (
        <p className="text-sm text-gray-400 italic">Messenger not configured yet.</p>
      )}
    </div>
  );
}
